import * as React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import AdventureList from "../components/AdventureList";
import Footer from "../components/Footer";
import Reviews from "../components/Reviews";
import Subscribe from "../components/Subscribe";

import ReactGA from 'react-ga4';

export default class Blog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navActive: false,
      screenWidth: window.innerWidth,
      stories: [
        {
          id: 1,
          slug: "northern-lights-2025-season-almost-at-an-end",
          title: "Northern Lights 2025 season almost at an end!",
          date: "April 19, 2025",
          image: "/img/DSC01360.jpg"
        },
        {
          id: 2,
          title: "Glacier hike from Reykjavik",
          date: "March 1, 2024",
          image: "/img/66-min.jpg"
        },
        {
          id: 3,
          title: "Volcanic activity in Iceland",
          date: "February 13, 2024",
          image: "/img/received_272992901172816.jpeg"
        },
        {
          id: 4,
          title: "Christmas buffet in the highlands",
          date: "December 20, 2024",
          image: "/img/IMG20241216084120.jpg"
        },
        {
          id: 5,
          title: "Staff trip to the Ancient Trails",
          date: "June 20, 2024",
          image: "/img/NorseAdventures_2024 20-resize-compress.jpg"
        },
      ]
    };

    this.hideNav = this.hideNav.bind(this);
    this.showNav = this.showNav.bind(this);
  }

  hideNav() {
    this.setState({ navActive: false });
  }

  showNav() {
    this.setState({ navActive: true });
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    if (this.state.navActive && window.innerWidth < 1440) {
      document.body.classList.add("overflow-hidden");
    } else document.body.classList.remove("overflow-hidden");

    window.addEventListener("resize", () => {
      this.setState({
        screenWidth: window.innerWidth,
      });
      if (this.state.navActive && window.innerWidth < 1440) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
        this.hideNav();
      }
    });

    document.title = "Blog | Norse Adventures";

    ReactGA.initialize('G-CZG7EJ3P8E');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }

  componentDidUpdate() {
    if (this.state.navActive && window.innerWidth < 1440) {
      document.body.classList.add("overflow-hidden");
    } else document.body.classList.remove("overflow-hidden");
  }

  render() {
    return (
      <div className={"App flex flex-col items-center"}>
        <div className="bg-gray-900 text-white w-full p-2">
          The website is in development so you can expect some errors or display
          problems. Not all buttons and links work.
        </div>

        <header
          className={
            "flex flex-col items-center desktop:justify-center w-full group overflow-hidden" +
            (this.state.navActive & (this.state.screenWidth < 1440)
              ? " absolute"
              : " h-60 relative")
          }
        >
          <div
            className={
              "z-40 flex flex-row items-center justify-center w-full desktop:h-auto desktop:absolute desktop:top-0 desktop:left-0" +
              (this.state.navActive & (this.state.screenWidth < 1440)
                ? " h-screen flex-col"
                : "")
            }
          >
            <div
              className={
                "w-full h-full desktop:max-w-[1280px] flex bg-neutral-900 text-white desktop:m-16 " +
                (this.state.navActive & (this.state.screenWidth < 1440)
                  ? " flex-col items-center justify-center"
                  : " flex-row" + (this.state.screenWidth < 1440 ? " bg-opacity-100" : " bg-opacity-90"))
              }
            >
              <a href="/">
                <div className="p-8 hover:bg-neutral-900">
                  <img
                    src="/runes.svg"
                    alt="Norse Logo"
                    className="invert w-48"
                  />
                </div>
              </a>
              <div
                id="navlinks"
                className={
                  "flex flex-col desktop:flex-row desktop:ml-auto text-xl font-black" +
                  (!this.state.navActive ? " ml-auto" : "")
                }
              >
                {this.state.navActive || this.state.screenWidth >= 1440 ? (
                  <>
                    <HashLink
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center items-center"
                      to="/#adventures"
                    >
                      ADVENTURES
                    </HashLink>
                    <Link
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center items-center"
                      to="/about-us"
                    >
                      ABOUT US
                    </Link>
                    <Link
                      onClick={this.hideNav}
                      className="p-8 bg-neutral-900 h-full flex flex-col justify-center items-center"
                      to="/blog"
                    >
                      BLOG
                    </Link>
                    <a
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center items-center"
                      href="#contact-us"
                    >
                      CONTACT US
                    </a>
                  </>
                ) : (
                  <button onClick={this.showNav} className="text-3xl p-8">
                    ☰
                  </button>
                )}
              </div>
            </div>
          </div>

          {this.state.navActive && (
            <button
              onClick={this.hideNav}
              className="text-3xl p-8 absolute top-0 right-0 text-white z-50"
            >
              ☰
            </button>
          )}
        </header>

        <main class="flex flex-col p-4 laptop:p-16 w-full max-w-screen-desktop">
          <section className="text-gray-700">
            <div className="grid grid-cols-4 gap-8 gap-y-16">
              {this.state.stories.length > 0 ? (
                this.state.stories.map((e, id) => (
                  <Link to={e.slug} className={(id === 0 ? " col-span-2" : " col-span-1")}>
                    <div data-id={id + 1} className="overflow-hidden flex flex-col items-start w-full gap-4 group cursor-pointer">
                      <img
                        alt="stories"
                        className="block object-cover object-center w-full aspect-[3/2] rounded-lg group-hover:brightness-110 bg-black"
                        src={e.image}
                      />
                      <div>
                        <span className="text-black text-xl font-bold">{e.date}</span>
                        <h2 className="text-black text-2xl">{e.title}</h2>
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <span className="text-4xl col-span-full text-center">
                  No Stories Found
                </span>
              )}
            </div>
          </section>
        </main>

        {/* Divider */}
        <div className="w-full h-32 bg-neutral-100"></div>

        <Subscribe />
        <Footer />
      </div>
    );
  }
}
